import { Profile } from '@quick/client';

export const firstMultiFactor = (profile: Profile | undefined) => {
  if (!profile || profile.enrolledMultiFactors.length === 0) {
    return undefined;
  }
  return profile.enrolledMultiFactors[0];
};
